import { createSlice } from '@reduxjs/toolkit'

const initialStockItemsStats = {
  inventory: 0,
  pending: 0,
};

export const stockItemsStatsSlice = createSlice({
  name: 'stockItemsStats',
  initialState: {
    value: { ...initialStockItemsStats},
  },
  reducers: {
    setStockItemsStats: (state, action) => {
        state.value = action.payload;
    },
  },
})

export const { setStockItemsStats } = stockItemsStatsSlice.actions

export const selectStockItemsStats = (state) => state.stockItemsStats.value

export default stockItemsStatsSlice.reducer